module.exports = __webpack_public_path__ + "static/media/all_location.bcec52ec.png";